import { CustomerApiKey } from 'src/interfaces/apiKey'
import { State } from 'src/reducers/types'

export const getCustomerApiKeys = (state: State): Array<CustomerApiKey> => state.apiKey.apiKeys
